// extracted by mini-css-extract-plugin
export const registrationPane = "style-module--registrationPane--2lN14";
export const submit = "style-module--submit--l0GLP";
export const formElement = "style-module--formElement--37iWv";
export const field = "style-module--field--3SYkw style-module--formElement--37iWv";
export const verticalForm = "style-module--verticalForm--2cvux";
export const header = "style-module--header--3KN7S";